import { Banner } from '@sunwebgroup/uds-ui/banner'
import { useIntl } from '@/intl'
import styles from './ParticipantEditShared.module.css'

export function ParticipantEditSaveErrorBanner() {
  const { formatMessage } = useIntl()

  return (
    <Banner hasIcon color="danger" size="M" className={styles.stickyBanner}>
      <Banner.TextsWrapper>
        <Banner.Text>{formatMessage({ id: 'common_error_title' })}</Banner.Text>
        <Banner.SupportingText>{formatMessage({ id: 'save_error' })}</Banner.SupportingText>
      </Banner.TextsWrapper>
    </Banner>
  )
}
